import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { PUBLIC_ROUTES } from "../routes";
import NavBar from "components/NavBar";
import ScrollToTop from "components/ScrollToTop";
const Unauthenticated = () => {
  const routes = useRoutes(PUBLIC_ROUTES);
  return routes;
};
const AppWrapper = () => {
  return (
    <Router>
      <ScrollToTop />
      <NavBar />
      <Unauthenticated />
    </Router>
  );
};
export default AppWrapper;
